class Str {
  static hyphen(phoneNumber: string | null | undefined) {
    if (!phoneNumber) return '-';

    return phoneNumber
      .replace(/[^0-9]/g, '')
      .replace(/^02(\d{3,4})(\d{4})$/, '02-$1-$2')
      .replace(/^(\d{3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }

  static hyphenForCorpRegNo(corpRegNo: string | null | undefined) {
    if (!corpRegNo) return '-';

    return corpRegNo
      .replace(/[^0-9]/g, '') // Remove any non-digit characters
      .replace(/^(\d{3})(\d{2})(\d{5})$/, '$1-$2-$3'); // Format into 3-2-5 pattern
  }

  static randomNumberStr(length: number): string {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  static randomAlphaNumericStr(length: number): string {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  static isYouTubeLink = (str: string): boolean => {
    const pattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return pattern.test(str);
  };

  static isVimeoLink = (url: string): boolean => {
    const pattern = /^(https?:\/\/)?(www\.)?(vimeo\.com)\/.+$/;
    return pattern.test(url);
  };

  static isVideoLink = (url: string): boolean => {
    return Str.isYouTubeLink(url) || Str.isVimeoLink(url);
  };

  static isWebLink(str: string): boolean {
    const pattern = /^https?:\/\/.+/;
    return pattern.test(str);
  }
}

export default Str;
